import { render, staticRenderFns } from "./imcNinos0a2A.vue?vue&type=template&id=76ccca60&scoped=true"
import script from "./imcNinos0a2A.vue?vue&type=script&lang=js"
export * from "./imcNinos0a2A.vue?vue&type=script&lang=js"
import style0 from "./imcNinos0a2A.vue?vue&type=style&index=0&id=76ccca60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ccca60",
  null
  
)

export default component.exports